import apiClient from "@/axiosConfig";

export default {
  getOrders() {
    return apiClient.get("/billing/orders");
  },

  createOrder(payload) {
    return apiClient.post("/billing/orders", payload);
  },

  getSourceAssignments(sourceSystem) {
    return apiClient.get("/billing/source-assignments", { params: { sourceSystem } });
  },

  createSourceAssignment(payload) {
    return apiClient.post("/billing/source-assignments", payload);
  },

  createPreview(payload) {
    return apiClient.post("/billing/runs/preview", payload);
  },

  getRun(billingRunId) {
    return apiClient.get(`/billing/runs/${billingRunId}`);
  },

  approve(billingRunId, orderId, payload) {
    return apiClient.post(
      `/billing/runs/${billingRunId}/orders/${orderId}/approval`,
      payload
    );
  },

  generateDocuments(billingRunId, orderId, payload) {
    return apiClient.post(
      `/billing/runs/${billingRunId}/orders/${orderId}/documents`,
      payload
    );
  },

  finalize(billingRunId, orderId, payload) {
    return apiClient.post(
      `/billing/runs/${billingRunId}/orders/${orderId}/finalization`,
      payload
    );
  },

  markSent(billingRunId, orderId, payload) {
    return apiClient.post(
      `/billing/runs/${billingRunId}/orders/${orderId}/dispatch`,
      payload
    );
  },

  cancel(billingRunId, orderId, payload) {
    return apiClient.post(
      `/billing/runs/${billingRunId}/orders/${orderId}/cancellation`,
      payload
    );
  },

  recoverDispatch(billingRunId) {
    return apiClient.post(`/billing/runs/${billingRunId}/dispatch/recovery`, {});
  },

  dispatchFeedback(billingRunId, maximumCount = 25) {
    return apiClient.post(`/billing/runs/${billingRunId}/feedback/dispatch`, {}, {
      params: { maximumCount },
    });
  },
};
